<template>
  <div class="container">
    <div class="section us-page">
      <nav class="us-crumbs" aria-label="Ruta">
        <router-link :to="{ name: 'usermenu' }">Usuarios</router-link>
        <span>/</span>
        <span>Crear usuario</span>
      </nav>

      <div class="us-header">
        <h1 class="us-title">Crear usuario</h1>
        <p class="us-subtitle">
          Crea una persona con acceso a la plataforma y define qué puede ver
        </p>
      </div>

      <div class="us-two">
        <div class="us-stack">
          <div class="box us-box">
            <div class="us-lead">
              <h2>Datos del usuario</h2>
              <p>
                La persona recibirá un correo con el botón para crear su
                contraseña.
              </p>
            </div>
            <div class="us-grid2">
              <div class="us-field">
                <label>Nombre</label>
                <b-input
                  v-model="user.displayName"
                  placeholder="Nombre completo"
                ></b-input>
              </div>
              <div class="us-field">
                <label>Correo</label>
                <b-input
                  v-model="user.email"
                  type="email"
                  placeholder="correo@empresa.com"
                ></b-input>
              </div>
            </div>
            <div class="us-field">
              <label>Empresa</label>
              <v-select
                class="us-select"
                label="nombre"
                :options="empresas"
                v-model="current"
                placeholder="Seleccione una empresa"
              ></v-select>
              <p class="us-hint">
                Queda como su empresa seleccionada. Después puedes asignarle más
                empresas desde Editar usuario.
              </p>
            </div>
          </div>

          <div class="box us-box">
            <div class="us-lead">
              <h2>Permisos</h2>
              <p>
                Elige el tipo de usuario y, si es cliente, los módulos a los que
                entra.
              </p>
            </div>
            <permissions-form
              :claims="user.claims"
              @toggle="onToggleClaim"
            ></permissions-form>
          </div>

          <employee-picker
            v-if="user.claims.liderl"
            :employees="listempleados"
            :selected-id="user.empleado || ''"
            @load="traeempleados"
            @select="seleccionar"
          ></employee-picker>

          <div class="us-savebar">
            <p class="us-hint">
              Al guardar se crea el usuario y se envía el correo.
            </p>
            <div class="buttons">
              <router-link :to="{ name: 'usermenu' }" class="button">
                Cancelar
              </router-link>
              <b-button type="is-dark" @click="enviar">Crear usuario</b-button>
            </div>
          </div>
        </div>

        <aside class="us-aside">
          <user-summary
            :user="user"
            :company-name="currentName"
            note="Se actualiza mientras llenas el formulario."
          ></user-summary>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PermissionsForm from "../components/PermissionsForm.vue";
import UserSummary from "../components/UserSummary.vue";
import EmployeePicker from "../components/EmployeePicker.vue";

export default {
  components: {
    vSelect,
    PermissionsForm,
    UserSummary,
    EmployeePicker,
  },
  data() {
    return {
      user: {
        displayName: "",
        email: "",
        currentCompany: "",
        companys: {},
        claims: {},
      },
      empresas: [],
      current: "",
      listempleados: [],
    };
  },
  computed: {
    currentId() {
      return (this.current && this.current._id) || "";
    },
    currentName() {
      return (this.current && this.current.nombre) || "";
    },
  },
  methods: {
    onToggleClaim(key, value) {
      this.$set(this.user.claims, key, value);
    },
    seleccionar(d) {
      this.$set(this.user, "empleado", d._id);
    },
    async enviar() {
      let result;

      if (
        (this.user.claims.admin || this.user.claims.cliente) &&
        this.currentId &&
        this.user.displayName &&
        this.user.email
      ) {
        try {
          this.user.currentCompany = this.currentId;
          this.user.companys = {};
          this.user.companys[this.currentId] = {
            id: this.currentId,
          };
          result = await apiServices.post(`/users`, this.user);
          if (result) {
            const body = result.data;
            const isObject = body !== null && typeof body === "object";
            if (isObject && body.notsaved) {
              this.$store.dispatch("notify", {
                message: "Este usuario ya existe; no se envió ningún correo",
                type: "is-warning",
                duration: 6000,
              });
              return;
            }
            if (isObject && body.emailSent === false) {
              console.log(body.emailError);
              this.$store.dispatch("notify", {
                message:
                  "Usuario creado, pero no se pudo enviar el correo. Reenvíalo desde el listado de usuarios",
                type: "is-warning",
                duration: 6000,
              });
            } else {
              this.$store.dispatch("notify", {
                message: `Perfecto. Usuario creado con éxito`,
              });
            }
            this.$router.push({ name: "usermenu" });
          }
        } catch (error) {
          console.log(error);
          this.$store.dispatch("notify", {
            message: "Ups, ocurrió un error. Inténtelo nuevamente",
            type: "is-danger",
            duration: 4000,
          });
        }
      } else {
        let mess;
        if (!(this.user.claims.admin || this.user.claims.cliente))
          mess = "Selecciona por favor tipo de usuario";
        else if (!this.user.displayName) mess = "Ingresa nombre de usuario";
        else if (!this.user.email) mess = "Ingresa correo de usuario";
        else if (!this.currentId)
          mess = "Selecciona una empresa para el usuario";

        this.$store.dispatch("notify", {
          message: mess,
          type: "is-danger",
          duration: 4000,
        });
      }
    },
    async traeempleados() {
      this.listempleados = [];
      let result;
      try {
        result = await apiServices.get(`/listliderempleados/cpy`);
        if (result.data) {
          this.listempleados = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async loadCompanies() {
      let result;
      const d = {
        _id: "",
        nombre: "",
        nit: "",
      };
      try {
        result = await apiServices.get(`/empresas`);
        this.empresas = [].concat([d], result.data);
        this.empresas.sort((a, b) => a.nombre.localeCompare(b.nombre));
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.loadCompanies();
  },
  watch: {
    "user.claims": {
      handler(newValue) {
        if (newValue.admin) {
          Object.keys(newValue).map((x) => {
            if (x !== "admin") {
              this.user.claims[x] = false;
            }
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style src="../styles.css"></style>



// WEBPACK FOOTER //
// src/components/users/views/AddUser.vue